module.exports = __webpack_public_path__ + "img/task-white.31696c18.svg";